import { useMemo } from 'react'
import { BOOST_WEIGHT, DURATION_FACTOR, Locked2Flexible, VaultKey } from '@pancakeswap/pools'
import BigNumber from 'bignumber.js'
import { useCakeVault, useVaultPoolByKey } from 'state/pools/hooks'
import { getFullDecimalMultiplier } from '@pancakeswap/utils/getFullDecimalMultiplier'

import { DEFAULT_TOKEN_DECIMAL } from 'config'
import formatSecondsToWeeks, { secondsToWeeks } from '../../utils/formatSecondsToWeeks'

export default function useAvgLockDuration(vaultKey: VaultKey = VaultKey.CakeVault) {
  const { totalLockedAmount, totalShares, totalCakeInVault, pricePerFullShare } = useVaultPoolByKey(vaultKey)
  const { totalShares: flexibleShares } = useVaultPoolByKey(Locked2Flexible(vaultKey))

  const avgLockDurationsInSeconds = useMemo(() => {
    // const flexibleCakeAmount = totalCakeInVault.minus(totalLockedAmount)
    // const flexibleCakeShares = flexibleCakeAmount.div(pricePerFullShare).times(DEFAULT_TOKEN_DECIMAL)
    const lockedCakeBoostedShares = totalShares.minus(flexibleShares)
    const lockedCakeOriginalShares = totalLockedAmount?.div(pricePerFullShare).times(DEFAULT_TOKEN_DECIMAL)
    const avgBoostRatio = lockedCakeBoostedShares.div(lockedCakeOriginalShares)

    return (
      Math.round(
        avgBoostRatio
          .minus(1)
          .times(new BigNumber(DURATION_FACTOR.toString()))
          .div(new BigNumber(BOOST_WEIGHT.toString()).div(getFullDecimalMultiplier(12)))
          .toNumber(),
      ) || 0
    )
  }, [totalCakeInVault, totalLockedAmount, pricePerFullShare, totalShares, flexibleShares])

  const avgLockDurationsInWeeks = useMemo(
    () => formatSecondsToWeeks(avgLockDurationsInSeconds),
    [avgLockDurationsInSeconds],
  )

  const avgLockDurationsInWeeksNum = useMemo(
    () => secondsToWeeks(avgLockDurationsInSeconds),
    [avgLockDurationsInSeconds],
  )

  return {
    avgLockDurationsInWeeks,
    avgLockDurationsInWeeksNum,
    avgLockDurationsInSeconds,
  }
}
